// extracted by mini-css-extract-plugin
module.exports = {"bouncingTruck":"bouncing-truck_bouncingTruck__3YknY","bouncingAnimation":"bouncing-truck_bouncingAnimation__EqwHd"};